import { render } from "./FlowSidebar.vue?vue&type=template&id=0f597f42"
import script from "./FlowSidebar.vue?vue&type=script&lang=js"
export * from "./FlowSidebar.vue?vue&type=script&lang=js"
script.render = render

export default script